























import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import InformationKey from "@/components/information-key";
import _ from "lodash";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    if (!context.root.$route.params.id) {
      context.root.$router.push({ name: "404" });
    }

    const informationStore = inject(InformationKey);
    if (!informationStore) {
      throw new Error(`${InformationKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);

    const informationList = computed(() => informationStore.informationList);

    const information = ref(null);

    onMounted(async () => {
      information.value = null;
      informationStore.setAuthorizationHeader(accessToken.value);
      await informationStore.getInformationCategoryList();
      await informationStore.getInformationList();
      // 該当のものを検索（個別取得では表示期間でマスクしていないのでリストから取得）
      information.value = _.find(informationList.value, {
        id: Number(context.root.$route.params.id)
      });
      if (!information.value) {
        context.root.$router.push({ name: "404" });
        return;
      }
    });

    return {
      information
    };
  },
  components: {}
});
